window.RechargeBundle = { 
  onAddToCart: () => { 
    var cart = new theme.CartDrawer
cart.init()
cart.open(); 
  } 
}

var cameFromReload = false;
document.addEventListener("bundling-widget:ready",
  (event) => {
    if (!cameFromReload)
    {
      setTimeout(checkForSellingPlanList, 300);  
    }
    
  }
);

function checkForSellingPlanList()
{
  if (jQuery("#selling-plan-list").length <= 0)
  {
    setTimeout(checkForSellingPlanList, 300);
  }
  else
  {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const frequency = decodeURI(urlParams.get('frequency'));
    console.log("Frequency: " + frequency);
  
    if (frequency !== null)
    {
      jQuery("#selling-plan-list option").each(function()
       {
         if (jQuery(this).find("span").html() == frequency)
         {
           jQuery("#selling-plan-list option").each(function(index)
           {
             if (jQuery(this).find("span").html() == frequency)
             {
               jQuery(this).closest("select").get(0).selectedIndex = index;
               jQuery(this).closest("select").get(0).dispatchEvent(new Event('change'));
             }
           });
         }
       });
    }
  }
}

function clickIt(frequency)
{
  
  jQuery("#selling-plan-list option").each(function(index)
       {
         if (jQuery(this).find("span").html() == frequency)
         {
           jQuery(this).closest("select").get(0).selectedIndex = index;
           jQuery(this).closest("select").get(0).dispatchEvent(new Event('change'));
         }
       });
}
